import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";

export default function ModifyQuoteModal({ open, setOpen, onAction }) {
  const onClickAction = () => {
    onAction();
    setOpen(false);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">
            Are you sure you want to modify the original quote?
          </Title>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onClickAction} isFullWidth>
                Confirm
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
